<template>
  <v-navigation-drawer v-if="drawerInternal" v-model="drawerInternal" width="300" app right>
    <v-container fluid>
      <v-row align="center" class="panelheader">
        <v-col cols="10" class="text-h6 font-weight-light d-flex align-center">
          <v-icon color="primary" class="mr-3" @click="goToVisiteCarri" title="Vai a visite carro">mdi-link</v-icon> {{
            licensePlate }}
        </v-col>
        <v-col cols="2">
          <v-icon @click="closeInput()" title="Chiudi">mdi-close</v-icon>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="12">
          <v-expansion-panels accordion>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-icon class="accordion-icon">mdi-upload</v-icon>
                <span>Export</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-for="utiCarro in orderedExportUties" :key="utiCarro.id">
                  <wagon-dialog-uti-details :utiCarro="utiCarro" :features="features" />
                  <br />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-icon class="accordion-icon">mdi-download</v-icon>
                <span>Import</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-for="utiCarro in orderedImportUties" :key="utiCarro.id">
                  <wagon-dialog-uti-details :utiCarro="utiCarro" :features="features" />
                  <br />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-icon class="accordion-icon">mdi-information</v-icon>
                <span>Info</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="d-flex flex-row justify-space-between">
                  <div class="d-flex flex-column">
                    <div>{{ $t('plate') }}: {{ licensePlate }}</div>
                    <div>{{ $t('type') }}: {{ type }}</div>
                    <div>{{ $t('scope') }}: {{ scope }} {{ $t('kg') }}</div>
                    <div>{{ $t('tare') }}: {{ tare }} {{ $t('kg') }}</div>
                    <div>{{ $t('lenght') }}: {{ length }} {{ $t('m') }}</div>
                    <div>{{ $t('teu') }}: {{ teu }}</div>
                  </div>
                  <div class="wagon-feature align-self-center mr-3">
                    <v-icon v-if="danniCarroConvoglio.length > 0" color="warning">
                      mdi-alert
                    </v-icon>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-icon class="accordion-icon">mdi-tape-measure</v-icon>
                <span>Misure</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="d-flex flex-column">
                  <div>{{ $t('lenght') }}: {{ length }} {{ $t('m') }}</div>
                  <div>{{ $t('position') }}: {{ posizioneBinario }} {{ $t('m') }}</div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-icon class="accordion-icon">mdi-train</v-icon>
                <span>Viaggi</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container fluid class="px-0 mx-0">
                  <div class="d-flex flex-row justify-space-between" v-if="carroConvoglio.viaggioIn">
                    <div class="d-flex flex-column">
                      <div>Viaggio IN - {{ viewNomeViaggio() ?
                        carroConvoglio.viaggioIn.nome : carroConvoglio.viaggioIn.codice }}</div>
                      <div> {{ carroConvoglio.viaggioIn.eta }} da {{
                        carroConvoglio.viaggioIn.nodoPartenza.descrizione }} </div>
                    </div>
                    <div class="wagon-feature align-self-center">
                      <v-icon color="primary" @click="goToViaggioIn"
                        title="Vai a pianificazione Viaggio IN">mdi-link</v-icon>
                    </div>
                  </div>
                  <div class="d-flex flex-row justify-space-between" v-if="carroConvoglio.viaggioOut">
                    <div class="d-flex flex-column">
                      <div>Viaggio OUT - {{ viewNomeViaggio() ?
                        carroConvoglio.viaggioOut.nome : carroConvoglio.viaggioOut.codice }}</div>
                      <div> {{ carroConvoglio.viaggioOut.etd }} da {{
                        carroConvoglio.viaggioOut.nodoArrivo.descrizione }} </div>
                    </div>
                    <div class="wagon-feature align-self-center">
                      <v-icon color="primary" @click="goToViaggioOut"
                        title="Vai a pianificazione Viaggio OUT">mdi-link</v-icon>
                    </div>
                  </div>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import convoyVisualizationMixins from "./mixins/convoyVisualizationMixins";
import wagonDialogUtiDetails from "./WagonDialogUtiDetails";
import railsMixins from "./mixins/railsMixins";

export default {
  name: "wagonDialog",
  components: {
    wagonDialogUtiDetails,
  },
  props: {
    carroConvoglio: {
      type: Object | null,
      required: true,
    },
    drawer: {
      type: Boolean,
      default: false,
    },
    plannedShowing: {
      type: Boolean,
      default: false,
    },
    features: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [convoyVisualizationMixins, railsMixins],
  data() {
    return {
      drawerInternal: false,
      danniCarroConvoglio: [],
    };
  },
  watch: {
    drawer: function (value) {
      if (value) {
        this.drawerInternal = value;
      }
    },
    carroConvoglio: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.id) {
          this.loadDanni(newVal.id);
        }
      }
    }
  },
  mounted() {
    this.drawerInternal = this.drawer;
  },
  computed: {
    orderedImportUties() {
      if (!this.plannedShowing) {
        return this.getRTOrderedImportUties(this.carroConvoglio);
      }
      return this.getOrderedImportUties(this.carroConvoglio);
    },
    orderedExportUties() {
      if (!this.plannedShowing) {
        return this.getRTOrderedExportUties(this.carroConvoglio);
      }
      return this.getOrderedExportUties(this.carroConvoglio);
    },
    utiCount() {
      if (!this.plannedShowing) {
        return this.getRTCarroUtiCount(this.carroConvoglio);
      }
      return this.getCarroUtiCount(this.carroConvoglio);
    },
    length() {
      return this.getCarroLength(this.carroConvoglio);
    },
    licensePlate() {
      return this.getCarroLicensePlate(this.carroConvoglio);
    },
    type() {
      return this.getCarroType(this.carroConvoglio);
    },
    scope() {
      return this.getCarroPortataMax(this.carroConvoglio);
    },
    tare() {
      return this.getCarroTara(this.carroConvoglio);
    },
    teu() {
      return this.getConvoyLength();
    },
    posizioneBinario() {
      if (!isNaN(this.carroConvoglio.posizioneBinario)) {
        return parseFloat(this.carroConvoglio.posizioneBinario).toFixed(2);
      }
      return 0;
    },
  },
  methods: {
    closeInput() {
      this.drawerInternal = !this.drawerInternal;
      this.$emit("close", this.drawerInternal);
    },
    goToVisiteCarri() {
      const routeData = this.$router.resolve({ name: "visiteCarri", query: { targa: this.licensePlate } });
      window.open(routeData.href, "_blank");
    },
    goToViaggioIn() {
      const routeData = this.$router.resolve({ name: "pianificazioneViaggioArrivo", params: { viaggioTrenoId: this.carroConvoglio.viaggioIn.id } });
      window.open(routeData.href, "_blank");
    },
    goToViaggioOut() {
      const routeData = this.$router.resolve({ name: "pianificazioneViaggioPartenza", params: { viaggioTrenoId: this.carroConvoglio.viaggioOut.id } });
      window.open(routeData.href, "_blank");
    },
    async loadDanni(id) {
      try {
        const response = await this.$api.get(this.$apiConfiguration.BASE_PATH + "logDanni/carroConvoglio/" + id);
        this.danniCarroConvoglio = response || [];
      } catch (error) {
        console.error("Errore nel recupero dei danni:", error);
        this.danniCarroConvoglio = [];
      }
    },
  },
};
</script>

<style scoped>
.accordion-icon {
  display: inline;
}

.wagon-feature {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 3px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 3px !important;
}
</style>
